/**
 * Pure prune step for multi-select (kept react-free so it can be unit-tested without a
 * DOM/react test environment — see useSelection.ts for the hook that uses it).
 *
 * Keeps each selected id that is still loaded (`currentIds`) OR known-valid via
 * `selectableIds` (a folder-wide "select all" that materialized unloaded ids). Returns
 * `prev` unchanged when nothing is pruned, so the caller can skip a state update and avoid
 * a render loop.
 */
export function retainSelection(
  prev: Set<string>,
  currentIds: Set<string>,
  selectableIds: Set<string> | null,
): Set<string> {
  const next = new Set<string>();
  for (const id of prev) {
    if (currentIds.has(id) || (selectableIds && selectableIds.has(id))) next.add(id);
  }
  return next.size === prev.size ? prev : next;
}
